module.exports = __webpack_public_path__ + "static/media/job-01.13ef950a.jpg";